import http from '@/communication/AuthConnection'

export default async ({ commit, state }, { eventId }) => {
  const payload = {
    eventId
  }

  try {
    commit('CHANGE_DOWNLOAD_STATUS', 'inprogress')
    const result = await http.post(
      `/v1/rms/generate-package`,
      payload,
      {
        responseType: 'arraybuffer',
        encoding: null
      })

    // return setTimeout(() => {
    commit('CHANGE_DOWNLOAD_STATUS', 'standby')
      // commit('SET_TOTAL_BYTES', 0)
      // commit('PROGRESS_LOADED', 0)
    return result.data
    // }, 1000)
  } catch (e) {
    commit('CHANGE_DOWNLOAD_STATUS', 'standby')
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/rms/ExtractRmsFromList.js